module.exports = __webpack_public_path__ + "assets/icon-batteryContainer-with.1c04bbec.svg";